export default {
  TO: {
    HELP: 'Participants on this order will also receive this message',
    SELECT: 'Add recipient(s) to send a comment'
  },
  TEXT: {
    PLACEHOLDER: 'Enter a comment'
  }
}
